// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NxjLFT {
  display: flex;
  flex-direction: column;
}

.NY8rHb {
  position: relative;
  display: flex;
  min-height: var(--benefits-timeline-item-min-height, 60px);
  padding-bottom: var(--benefits-timeline-item-padding-bottom, var(--spacing-1-5, 12px));
}

.NY8rHb:last-child {
  padding-bottom: 0;
  min-height: var(--benefits-timeline-last-item-min-height, var(--benefits-timeline-item-min-height, 60px));
}

.Xo9jLC {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
}

.maFu1c {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
}

.s2ZDHv {
  width: 12px;
  height: 12px;
  color: #22c55e;
  color: var(--color-success-500, #22c55e);
  border-radius: 50%;
  flex-shrink: 0;
}

.yb9VC8 {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.yxDcLq {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.BgkMrq {
  position: absolute;
  top: var(--benefits-timeline-connector-top, 20px);
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: var(--benefits-timeline-connector-height, 32px);
  z-index: 0;
}

.pzhkfw {
  background-color: var(--status-success, #387c2b);
  background-color: var(--color-success-500, #387c2b);
}

.snWsqh {
  background: repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 3px, transparent 3px, transparent 6px);
}

.qvJ0bp {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.g3hDD5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.EmNd1S {
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  margin: 0;
}

.Pk6f57 {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-normal);
  color: var(--color-neutral-500);
  white-space: nowrap;
  margin-left: var(--spacing-4);
}

/* Step status variants */
.q_y8LB .EmNd1S {
  color: var(--color-neutral-900);
}

@keyframes m_oSjZ {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.GZN4wS {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid #666666;
  border-top: 2px solid transparent;
  border-radius: 50%;
  margin-left: var(--spacing-4);
  animation: kfhCJj 1s linear infinite;
}

@keyframes kfhCJj {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .NxjLFT {
    max-width: 100%;
  }

  .g3hDD5 {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1);
  }

  .Pk6f57 {
    margin-left: 0;
    font-size: var(--font-size-xs);
  }

  .GZN4wS {
    margin-left: 0;
    width: 10px;
    height: 10px;
    border-width: 1.5px;
  }

  .EmNd1S {
    font-size: var(--font-size-sm);
  }
}

@media (max-width: 480px) {
  .Xo9jLC {
    gap: var(--spacing-3);
  }

  .maFu1c {
    width: 20px;
  }

  .s2ZDHv,
  .yb9VC8 {
    width: 20px;
    height: 20px;
  }

  .yxDcLq {
    width: 20px;
    height: 20px;
  }

  .BgkMrq {
    top: 18px;
    height: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BenefitsTimeline/BenefitsTimeline.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0DAA0D;EAC1D,sFAAsF;AACxF;;AAEA;EACE,iBAAiB;EACjB,yGAAyG;AAC3G;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,uDAAuD;EACvD,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,mDAAmD;AACrD;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,YAAY;EACd;AACF","sourcesContent":[".timeline {\n  display: flex;\n  flex-direction: column;\n}\n\n.timelineItem {\n  position: relative;\n  display: flex;\n  min-height: var(--benefits-timeline-item-min-height, 60px);\n  padding-bottom: var(--benefits-timeline-item-padding-bottom, var(--spacing-1-5, 12px));\n}\n\n.timelineItem:last-child {\n  padding-bottom: 0;\n  min-height: var(--benefits-timeline-last-item-min-height, var(--benefits-timeline-item-min-height, 60px));\n}\n\n.timelineContent {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  gap: 8px;\n}\n\n.iconContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 24px;\n}\n\n.iconCompleted {\n  width: 12px;\n  height: 12px;\n  color: #22c55e;\n  color: var(--color-success-500, #22c55e);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.iconCurrent {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.iconPending {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.connector {\n  position: absolute;\n  top: var(--benefits-timeline-connector-top, 20px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: var(--benefits-timeline-connector-height, 32px);\n  z-index: 0;\n}\n\n.connectorCompleted {\n  background-color: var(--status-success, #387c2b);\n  background-color: var(--color-success-500, #387c2b);\n}\n\n.connectorPending {\n  background: repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 3px, transparent 3px, transparent 6px);\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.titleContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.stepTitle {\n  font-size: 12px;\n  font-weight: var(--font-weight-medium);\n  margin: 0;\n}\n\n.stepDate {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-normal);\n  color: var(--color-neutral-500);\n  white-space: nowrap;\n  margin-left: var(--spacing-4);\n}\n\n/* Step status variants */\n.itemCompleted .stepTitle {\n  color: var(--color-neutral-900);\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.stepLoading {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid #666666;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  margin-left: var(--spacing-4);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .timeline {\n    max-width: 100%;\n  }\n\n  .titleContainer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1);\n  }\n\n  .stepDate {\n    margin-left: 0;\n    font-size: var(--font-size-xs);\n  }\n\n  .stepLoading {\n    margin-left: 0;\n    width: 10px;\n    height: 10px;\n    border-width: 1.5px;\n  }\n\n  .stepTitle {\n    font-size: var(--font-size-sm);\n  }\n}\n\n@media (max-width: 480px) {\n  .timelineContent {\n    gap: var(--spacing-3);\n  }\n\n  .iconContainer {\n    width: 20px;\n  }\n\n  .iconCompleted,\n  .iconCurrent {\n    width: 20px;\n    height: 20px;\n  }\n\n  .iconPending {\n    width: 20px;\n    height: 20px;\n  }\n\n  .connector {\n    top: 18px;\n    height: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeline": `NxjLFT`,
	"timelineItem": `NY8rHb`,
	"timelineContent": `Xo9jLC`,
	"iconContainer": `maFu1c`,
	"iconCompleted": `s2ZDHv`,
	"iconCurrent": `yb9VC8`,
	"iconPending": `yxDcLq`,
	"connector": `BgkMrq`,
	"connectorCompleted": `pzhkfw`,
	"connectorPending": `snWsqh`,
	"contentContainer": `qvJ0bp`,
	"titleContainer": `g3hDD5`,
	"stepTitle": `EmNd1S`,
	"stepDate": `Pk6f57`,
	"itemCompleted": `q_y8LB`,
	"stepLoading": `GZN4wS`,
	"spin": `kfhCJj`,
	"pulse": `m_oSjZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
